export const AUTH_FLOW_SDK_PATH_LOGIN = 'auth/login';
export const AUTH_FLOW_SDK_PATH_LOGIN_CALLBACK = 'auth/callback';
export const AUTH_FLOW_DEVICE_PATH_LOGIN = 'auth/device';
export const AUTH_FLOW_CLIENT_CREDENTIALS_PATH_LOGIN = 'auth/client-credentials-login';
export const AUTH_FLOW_PATH_LOGOUT = 'auth/logout';
